import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { IconProps } from '../iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconActiveStar({
  extColor,
  isAutoscallable = true,
  sizeKey = '24x24',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.custom.isFavourite;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3623_37942)">
        <path d="M11.5009 -0.111412C11.196 -0.025156 10.9393 0.13118 10.7146 0.368382C10.6076 0.48159 10.0085 1.63525 9.09376 3.48433C8.29137 5.10161 7.63341 6.42778 7.62271 6.43856C7.61736 6.44934 6.20515 6.65959 4.48804 6.91296C2.77092 7.16094 1.28383 7.39275 1.17684 7.4197C0.88263 7.50057 0.497483 7.7809 0.315608 8.04505C0.0802397 8.39007 6.81976e-07 8.67579 6.81976e-07 9.1448C6.81976e-07 9.89414 -0.0106979 9.88336 2.64789 12.4926C4.48804 14.2985 4.96412 14.7999 4.94807 14.8861C4.93203 14.9454 4.69131 16.3525 4.4078 18.0129C3.84613 21.3175 3.82473 21.5601 4.0601 22.0183C4.24197 22.3795 4.54688 22.6814 4.89458 22.8485C5.16739 22.9779 5.27973 22.9995 5.64348 22.9941C5.91629 22.9941 6.14631 22.9617 6.29074 22.9024C6.40842 22.8539 7.73504 22.1639 9.23819 21.3714C10.7413 20.5736 11.9824 19.9266 11.9984 19.9266C12.0198 19.9266 13.1592 20.525 14.534 21.2528C17.9682 23.0803 17.8024 22.9995 18.2945 22.9995C18.8829 22.9995 19.1611 22.8863 19.5569 22.4927C19.9367 22.1046 20.0598 21.8081 20.0598 21.2798C20.0598 21.0803 19.8244 19.5493 19.5355 17.8404L19.0113 14.7567L21.3061 12.5087C22.5686 11.2688 23.6598 10.1691 23.7294 10.0613C23.9112 9.78632 24.0343 9.24723 23.9915 8.91299C23.9487 8.53563 23.6866 8.00732 23.4458 7.79168C23.034 7.43049 22.927 7.40892 19.5302 6.91296C17.781 6.65419 16.342 6.43856 16.3313 6.43317C16.326 6.42238 15.668 5.09622 14.8763 3.47894C13.5818 0.837391 13.416 0.519327 13.1859 0.30908C13.0522 0.185089 12.8275 0.0287533 12.6992 -0.025156C12.3943 -0.159929 11.8165 -0.203056 11.5009 -0.111412Z" />
      </g>
    </svg>
  );
}
